import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import './Badge.scss';

// interface BadgeProps {
//   children: React.ReactNode;
//   variant?: 'default' | 'primary' | 'secondary' | 'success' | 'warning' | 'danger';
//   size?: 'sm' | 'md' | 'lg';
//   icon?: React.ReactNode;
//   animate?: boolean;
//   className?: string;
// }

const Badge = forwardRef(
  (
    {
      children,
      variant = 'default',
      size = 'md',
      icon,
      animate = false,
      className = '',
      ...props
    },
    ref
  ) => {
    const classes = `badge badge-${variant} badge-${size} ${className}`.trim();

    const content = (
      <>
        {icon && <span className="badge-icon">{icon}</span>}
        <span className="badge-text">{children}</span>
      </>
    );

    if (animate) {
      return (
        <motion.span
          ref={ref}
          className={classes}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
          {...props}
        >
          {content}
        </motion.span>
      );
    }

    return (
      <span ref={ref} className={classes} {...props}>
        {content}
      </span>
    );
  }
);

Badge.displayName = 'Badge';

export default Badge;
